import styled from "styled-components";
import { DARK_GRAY, NEAR_WHITE } from "../../config";
import { Status } from "../../types";
import { getColorByStatusCode } from "../../utils";

export const SecondaryStatusTag = styled.div.attrs({
  "data-testid": "secondary-status-tag",
}) <{ statusCode: Status }>`
  width: 24px;
  height: 24px;
  border-radius: 100%;
  border-radius: 100%;
  clip-path: polygon(100% 37%, 0 100%, 100% 100%);
  background-color: ${({ statusCode }) => getColorByStatusCode(statusCode)};
`;


export const TagStatusContent = styled.div`
  .TagStatusTooltip {
    width: 180px;
    height: 62px;
    background-color: ${DARK_GRAY};
    color: ${NEAR_WHITE};
    border-radius: 4px;
    position: absolute;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin-left: 28px;
    margin-top: -20px;
    padding: 8px 16px;
    display: none !important;
  }

  width: fit-content;
  flex-direction: row;
  display: grid;
  -webkit-box-orient: horizontal !important;
  -webkit-box-pack: initial !important;

  &:hover {
    .TagStatusTooltip {
      display: flex !important;
    }
  }
`;

export const FamilyStatus = styled.div`
  font-weight: bold;
  font-size: 15px;
  line-height: 14px;
  width: 100%;
  margin-bottom: 5px;
`;